import type { InstallationManifest } from '../fleetRecoveryTypes';

/** A reboot grants no file, installer, driver or foundation mutation authority. */
export class FleetRecoveryRebootManifest {
  public static readonly version = 'recovery-reboot-v4';
  public static readonly reference = { manifestSha256: '0'.repeat(64), packageSha256: '0'.repeat(64) };
  public static create(): InstallationManifest {
    return { schemaVersion: 2, productVersion: this.version, platform: 'windows', requiredFreeBytes: '1',
      minRescueProtocol: 4, artifacts: [], targets: [], ownershipRules: [], readiness: [], preserveRoots: [] };
  }
  public static matches(manifest: InstallationManifest): boolean {
    return manifest.productVersion === this.version && manifest.schemaVersion === 2 && manifest.platform === 'windows'
      && manifest.requiredFreeBytes === '1' && manifest.minRescueProtocol === 4 && !manifest.authorityTransition
      && [manifest.artifacts, manifest.targets, manifest.ownershipRules, manifest.readiness, manifest.preserveRoots].every(items => items.length === 0);
  }
}
